export class AppConsts {

  static remoteServiceBaseUrl: string;
  static JobFilesDataSource: number;
  static appBaseUrl: string;
  static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

  static AD_CONFIG: any;
  static ALLOWED_DOMAINS:any;
  static localeMappings: any = [];
  static GuidedownloadUrl: string;
}
